import { __module as i } from "./chunk773.js";
import { __require as m } from "./chunk648.js";
import { __require as _ } from "./chunk665.js";
var v = i.exports, c;
function b() {
  return c ? i.exports : (c = 1, function(f, h) {
    (function(e, r, n) {
      f.exports = r(m(), _());
    })(v, function(e) {
      return e.mode.OFB = function() {
        var r = e.lib.BlockCipherMode.extend(), n = r.Encryptor = r.extend({
          processBlock: function(a, p) {
            var s = this._cipher, d = s.blockSize, u = this._iv, t = this._keystream;
            u && (t = this._keystream = u.slice(0), this._iv = void 0), s.encryptBlock(t, 0);
            for (var o = 0; o < d; o++)
              a[p + o] ^= t[o];
          }
        });
        return r.Decryptor = n, r;
      }(), e.mode.OFB;
    });
  }(i), i.exports);
}
export {
  b as __require
};
